import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import {
  classAllAssignmentsFetchStateConfig,
  classCurrentAssignmentsFetchStateConfig
} from "../../../../consts";

export const classFutureAssignmentsMetaReducer = makeCrudStateReducer(
  classCurrentAssignmentsFetchStateConfig
);

export const classAllAssignmentsMetaReducer = makeCrudStateReducer(
  classAllAssignmentsFetchStateConfig
);
